import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import ScrollArea from '../../partials/ScrollArea'

import FilterBox from './FilterBox'

import color from '../../../utils/color'

import style from '../style'

const OWNER_TYPE = ['private', 'community']
const CATEGORY_LIST = ['financial', 'technical', 'other']
const STATUS_TYPE = ['open', 'resolved']
const PRIORITY_TYPE = ['low', 'mid', 'high']

const TicketTable = props => {
  return (
    <Row
      style={{
        minHeight: `500px`,
        height: `100%`
      }}
    >
      <Col>
        <ScrollArea
          style={{
            width: 'auto',
            minHeight: `500px`,
            height: `calc(100vh - 300px)`,
            margin: `0 -15px`,
            marginBottom: 0,
            paddingRight: `15px`,
            paddingLeft: `15px`,
            overflowX: `hidden`,
            ...(props.isEditorActive
              ? props.theme && props.theme.name === 'ColorBlind'
                ? { border: `1px solid #666` }
                : { border: `1px solid #f8f8f8` }
              : {})
            // borderTop: `none`
          }}
        >
          <Col>
            {props.tickets.map((item, index) => (
              <RenderTableRow
                theme={props.theme}
                key={index}
                {...item}
                owner={props.users.find(u => u.id === item.userId)}
                onTicketClick={props.onTicketClick}
                isEditorActive={props.isEditorActive}
              />
            ))}
          </Col>
        </ScrollArea>
      </Col>
    </Row>
  )
}

const RenderFilterBox = props => {
  if (props.filter.modal === '') {
    return null
  }

  const item = {}

  if (props.filter.modal === 'status') {
    item.value = props.filter.status
    item.onChange = props.setFilterStatus
  } else if (props.filter.modal === 'category') {
    item.value = props.filter.category
    item.onChange = props.setFilterCategory
  } else if (props.filter.modal === 'date_range') {
    item.value = props.filter.date_range
    item.onChange = props.setFilterDateRange
  }

  return (
    <Row className={css(style.filterbox.container)}>
      <Col xs='12'>
        <FilterBox
          onChange={item.onChange}
          type={props.filter.modal}
          value={item.value}
        />
      </Col>
    </Row>
  )
}

const RenderTableHeader = props => {
  const between = [
    new Date(props.filter.date_range[0]),
    new Date(props.filter.date_range[1])
  ]

  const _between = [
    {
      month: between[0].getUTCMonth() + 1,
      year: between[0].getUTCFullYear()
    },
    {
      month: between[1].getUTCMonth() + 1,
      year: between[1].getUTCFullYear()
    }
  ]

  _between[0].month = `${
    ('' + _between[0].month).length > 1
      ? _between[0].month
      : '0' + _between[0].month
  }`
  _between[1].month = `${
    ('' + _between[1].month).length > 1
      ? _between[1].month
      : '0' + _between[1].month
  }`

  return (
    <Row
      className={`d-flex align-items-end justify-content-start ${css(
        style.table.header
      )}`}
    >
      <Col>
        <Row className={`d-flex align-items-center justify-content-start`}>
          {/* <Col xs='auto' className={css(style.table.headerColumn)}>
            <span className={css(style.table.button)}>Close</span>
          </Col> */}
          <Col xs='auto' className={css(style.table.headerColumn)}>
            <span
              className={css(style.table.button)}
              onClick={() => props.toggleFilterBox()}
            >
              Filter
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

const RenderTableRow = props => {
  if (!props.owner) {
    return null
  }

  const userFullName = `${props.owner.firstName} ${props.owner.lastName}`
  const userHexColor = color.stringToHex(userFullName)
  const fontHexColor = color.contrastHex(userHexColor)

  const date = new Date(props.createdAt)
  const _date = {
    day: date.getUTCDate(),
    month: date.toLocaleString('en-us', { month: 'short' }),
    year: date.getUTCFullYear(),
    hour: date.getUTCHours() % 12,
    minutes: date.getUTCMinutes(),
    pm: date.getUTCHours() >= 12
  }

  _date.day = `${('' + _date.day).length > 1 ? _date.day : '0' + _date.day}`
  _date.month = `${
    ('' + _date.month).length > 1 ? _date.month : '0' + _date.month
  }`

  return (
    <Row
      className={css(
        style.table.row,
        style[props.theme.name] ? style[props.theme.name].table.row : null
      )}
      style={{ opacity: props.status === 1 ? 0.6 : 1 }}
      onClick={() => props.onTicketClick(props.id)}
    >
      {props.isEditorActive ? null : (
        <Col
          xs='1'
          className={`d-none d-lg-flex align-items-center justify-content-center`}
        >
          {props.status === 1 ? null : (
            <span
              className={css(
                style.status.box,
                style.status[PRIORITY_TYPE[props.priority]]
              )}
            />
          )}
        </Col>
      )}
      <Col xs='12' lg={props.isEditorActive ? `12` : `5`}>
        <Row>
          <Col xs='12'>
            <Row>
              <Col xs='auto'>
                <span className={css(style.table.category)}>
                  {(
                    (!CATEGORY_LIST[props.category]
                      ? CATEGORY_LIST[2]
                      : CATEGORY_LIST[+props.category]) + ':'
                  ).toUpperCase()}
                </span>
              </Col>
              <Col
                xs='auto'
                className={
                  props.isEditorActive ? `d-block` : `d-block d-lg-none`
                }
              >
                <span>&middot;</span>
              </Col>
              <Col
                xs='auto'
                className={
                  props.isEditorActive ? `d-block` : `d-block d-lg-none`
                }
              >
                <span
                  className={css(
                    style.table.author,
                    style[props.theme.name]
                      ? style[props.theme.name].table.author
                      : null
                  )}
                >
                  {props.owner.firstName} {props.owner.lastName}
                </span>
              </Col>
            </Row>
          </Col>
          <Col xs='12'>
            <Row className={`flex-nowrap`}>
              <Col
                xs='auto'
                className={`
                  ${props.isEditorActive ? `d-flex` : `d-flex d-lg-none`}
                  align-items-center justify-content-center
                `}
              >
                {props.status === 1 ? null : (
                  <span
                    className={css(
                      style.status.box,
                      style.status[PRIORITY_TYPE[props.priority]]
                    )}
                  />
                )}
              </Col>
              <Col className={`d-flex align-items-center`}>
                <span
                  className={css(
                    style.table.title,
                    style[props.theme.name]
                      ? style[props.theme.name].table.title
                      : null
                  )}
                >
                  {props.title}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      {props.isEditorActive ? null : (
        <Col className={`d-none d-lg-flex align-items-center`}>
          <Row>
            <Col xs='auto'>
              <RenderAvatar
                bgColor={userHexColor}
                textColor={fontHexColor}
                {...props.owner}
              />
            </Col>
            <Col>
              <Row>
                <Col>
                  <span className={css(style.table.category)}>
                    {!props.comId ? OWNER_TYPE[0] : OWNER_TYPE[+!!props.comId]}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span
                    className={css(
                      style.table.author,
                      style[props.theme.name]
                        ? style[props.theme.name].table.author
                        : null
                    )}
                  >
                    {props.owner.firstName} {props.owner.lastName}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      )}
      <Col xs='12' lg='auto'>
        <Row>
          {props.isEditorActive ? null : (
            <Col xs='12' className={`d-none d-lg-block`}>
              <span
                className={css(
                  style.table.datetime,
                  style.table.time,
                  style[props.theme.name]
                    ? (style[props.theme.name].table.datetime, style.table.time)
                    : null
                )}
              >
                {`${_date.hour}:${_date.minutes} ${_date.pm ? 'PM' : 'AM'}`}
              </span>
            </Col>
          )}
          <Col xs='12'>
            <span
              className={css(
                style.table.datetime,
                style.table.date,
                style[props.theme.name]
                  ? (style[props.theme.name].table.datetime, style.table.date)
                  : null
              )}
            >
              {`${_date.month} ${_date.day} ${_date.year}`}
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

const RenderAvatar = props => {
  return (
    <div
      className={`d-flex align-items-center justify-content-around ${css(
        style.author.avatarBox
      )}`}
      style={{ backgroundColor: props.bgColor }}
    >
      <span
        className={css(style.author.avatarSpan)}
        style={{ color: props.textColor }}
      >
        {`${props.firstName[0]}${props.lastName[0]}`}
      </span>
    </div>
  )
}

export default TicketTable



// WEBPACK FOOTER //
// ./src/components/Support/partials/TicketTable.js